<template>
    <div v-wechat-title="title" class="padding10" :style="{ 'min-height': `${this.screenHeight - 135}px` }">
        <el-row>
            <el-col :span="6" class="padding10">
                <item-input type="search" v-model="searchKey"></item-input>
            </el-col>
        </el-row>
        <el-row>
            <el-col :md="8" :lg="4" class="padding10" v-for="item in filter_score_items" :key="item.item_code">
                <div class="score-item padding10" :class="{ scored: item.result }">
                    <div :class="(item.score_many_times && hasDeletePermission) || (!item.score_many_times && hasDeletePermission) || item.creator == currentUser.dic_worker_name ? `score-left` : ``">
                        <div class="align-left font-size14 fg-main" style="height: 40px">
                            <!-- <span class="fg-info">{{ `(${item.item_code.replace('PF', '')})` }}</span > -->
                            {{ item.item_name }}
                            <span
                                v-if="item.score_many_times && item.allScores && item.allScores.length > 1"
                                class="el-icon-time"
                                style="cursor: pointer"
                                @click="ActiveItem(item)"
                                :title="getLog(item)"
                            ></span>
                        </div>
                        <div :class="item.level" class="score-main" v-if="item.result" :style="{ color: item.color, fontSize: (fontConfig && fontConfig.fontsize) || '24px' }">
                            <span class="cus-button" @click="ActiveItem(item)">{{ item.result }}</span>
                        </div>
                        <div v-else class="score-main">
                            <el-button v-if="hasAddPermission" type="primary" size="" plain circle icon="el-icon-plus" @click="ActiveItem(item)"></el-button>
                        </div>
                        <el-row v-if="item.result" class="fg-info font-size12">
                            <el-col :span="12" class="align-left padding5 padding-none-h">{{ item.modifier }}</el-col>
                            <el-col :span="12" class="align-right padding5 padding-none-h">{{ $moment(item.modify_date).format('MM/DD HH:mm') }}</el-col>
                        </el-row>
                    </div>
                    <div v-if="item.score_many_times && hasAddPermission && (hasDeletePermission || item.creator == currentUser.dic_worker_name)" class="score">
                        <div class="score-delete-new" @click="deleteDoc(item)"><span class="el-icon-delete"></span></div>
                        <div class="score-add bg-primary" @click="addDoc(item)"><span class="el-icon-plus"></span></div>
                    </div>
                    <div v-else-if="hasDeletePermission || item.creator == currentUser.dic_worker_name" class="score-delete bg-primary" @click="deleteDoc(item)">
                        <span class="el-icon-delete"></span>
                    </div>
                </div>
            </el-col>
        </el-row>
        <cus-dialog
            :title="active_item.item_name"
            :overflow="false"
            :delVisible="this.active_item.id && this.active_item.id > 0 && (hasDeletePermission || active_item.creator == currentUser.dic_worker_name)"
            :okVisible="(!this.active_item.id && hasAddPermission) || (this.active_item.id && this.active_item.id > 0 && hasEditPermission) || active_item.creator == currentUser.dic_worker_name"
            :printVisible="this.active_item.id && this.active_item.id > 0 && hasPrintPermission"
            :visible.sync="dialogFormVisible"
            :width="active_item.score_many_times && active_item.allScores && active_item.allScores.length > 0 ? `75%` : `60%`"
            @confirm="SaveChanges"
            @delete="deleteScore"
            @print="printScore"
        >
            <el-row>
                <el-col v-if="active_item.score_many_times && active_item.allScores && active_item.allScores.length > 0" :span="5" class="padding-right10">
                    <el-row v-if="hasAddPermission">
                        <span class="el-icon-plus" style="cursor: pointer; float: top; height: 15px" @click="addDoc(active_item)">新增评分</span>
                    </el-row>
                    <el-row>
                        <h1 class="align-left">评分记录:</h1>
                    </el-row>
                    <el-row>
                        <el-scrollbar :style="{ height: `${this.screenHeight - 500}px` }">
                            <div v-for="item in active_item.allScores" :key="item.id">
                                <div :class="item.id == active_item.id ? `score-record-active` : `score-record`" @click="loadscorerecord(active_item, item)">
                                    <span>{{ active_item.item_name }}</span>
                                    <span>
                                        <el-row class="fg-info font-size12">
                                            <el-col :span="14" class="align-left padding5 padding-none-h">{{ $moment(item.modify_date).format('YYYY/MM/DD HH:mm') }}</el-col>
                                            <el-col :span="6" class="align-right padding5 padding-none-h">{{ item.modifier }}</el-col>
                                            <el-col
                                                :span="4"
                                                class="padding5 padding-none-h"
                                                :style="{
                                                    color: `white`,
                                                    'font-weight': `bold`,
                                                    'background-color': `${item.color}`,
                                                    'text-align': `center`
                                                }"
                                                >{{ item.result }}</el-col
                                            >
                                        </el-row>
                                    </span>
                                </div>
                            </div>
                        </el-scrollbar>
                    </el-row>
                </el-col>
                <el-col :span="active_item.score_many_times && active_item.allScores && active_item.allScores.length > 0 ? 19 : 24">
                    <DocFrame
                        :docbizid.sync="active_item.docbizid"
                        ref="doc"
                        guid=""
                        :style="{ 'overflow-y': `auto`, height: `${this.screenHeight - 340}px` }"
                        :docno="(this.$root.DOCUMENT && this.$root.DOCUMENT[this.active_item.item_code]) || 0"
                        :surgeryId="surgeryId"
                        :docname="active_item.item_name || ''"
                        @saved="afterDocSaved"
                    ></DocFrame>
                </el-col>
            </el-row>
        </cus-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
    name: `Score`,
    prop: {

    },
    data() {
        return {
            title: `评分`,
            surgeryId: this.$route.query.surgery_id,
            token: this.$route.query.token,
            items: [],
            active_item: {},
            dialogFormVisible: false,
            scoreItems: [],
            defaultConfig: [],
            fontConfig: [],
            multiQueryProduceConfig: this.$root.MultiQueryProduceConfig == `1`,
            searchKey: ``
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.getToken()
        }
        this.$store.dispatch(`ADD_CURRENTUSER`)
    },
    computed: {
        ...mapGetters([`screenHeight`, `currentUser`, `sys_document_list`, `permissions`]),
        filter_score_items() {
            return _.filter(this.scoreItems, d => {
                return d.item_code.indexOf(this.searchKey) > -1 || d.item_name.indexOf(this.searchKey) > -1
            })
        },
        hasAddPermission() {
            return _.find(this.permissions, { no: `score_add` }) != undefined
        },
        hasEditPermission() {
            return _.find(this.permissions, { no: `score_edit` }) != undefined
        },
        hasDeletePermission() {
            return _.find(this.permissions, { no: `score_delete` }) != undefined
        },
        hasPrintPermission() {
            return _.find(this.permissions, { no: `score_print` }) != undefined
        }
    },
    mounted() {
        this.loadConfigSetting()
        this.loadScore()
    },
    methods: {
        getToken() {
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/GetAuthToken`, {
                headers: { 'content-type': `application/x-www-form-urlencoded` }
            })
            req.then(res => {
                console.log(`11111111111111111111111`, res)
                if (res != null && res.Status === `SUCCESS`) {
                    sessionStorage.setItem(`doctoken`, res.Content)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadConfigSetting() {
            let that = this
            let req = this.myaxios.get(`api/AcisSystem/Config/GetByKey?key=ScoreConfig`) // 获取参数信息
            req.then(data => {
                if (data) {
                    var configJson = JSON.parse(data.value)
                    that.defaultConfig = configJson.defaultConfig
                    that.fontConfig = configJson.fontConfig
                }
            }).catch(e => {
            })
        },
        ActiveItem(item) {
            this.active_item = item
            this.dialogFormVisible = true
            this.$nextTick(() => {
                this.$refs.doc && this.$refs.doc.loadDocument()
            })
        },
        afterDocSaved() {
            if (!this.surgeryId) return
            let info = { producename: `Sys_GetTotalScore ${this.active_item.docbizid}` }
            if (this.multiQueryProduceConfig) {
                info.validate = false
            }
            let catchscore = this.myaxios.post_doc(`Query/MultiQueryProduce`, info)
            let getall = this.myaxios.get(`/api/Nursing/Score/Get?surgeryId=${this.surgeryId}`)
            this.myaxios.all(catchscore, getall).then(([data, all]) => {
                let r = _.find(data, { Name: `total_score` })
                if (r && r.Textvalue) { // 同步分数到主站
                    // 已文书系统ID为唯一编码匹配，多次评分文书编码会重复，防止覆盖
                    let exist = _.find(all, { document_id: this.active_item.document_id })
                    return this.myaxios[exist ? `put` : `post`](`/api/Nursing/Score/${exist ? `Put` : `Post`}`, {
                        'id': exist && exist.id,
                        'biz_surgery_info_id': this.surgeryId,
                        'document_id': r.WTHMainId,
                        'document_name': this.active_item.item_code,
                        'result': r.Textvalue
                    })
                } else { //
                    this.$message.warning(`评分模板中未找到total_score书签,请修改模板！`)
                    return this.myaxios.get_doc(`/Wth/DeleteInstance`, { docbizid: this.active_item.docbizid, operator: this.currentUser.dic_worker_id })
                }
            }).then(() => {
                this.loadScore()
                this.dialogFormVisible = false
            }).catch(e => console.log(e))
        },
        SaveChanges() {
            this.$refs.doc.save()
        },
        deleteScore() {
            this.$confirm(`此操作将永久删除该评分记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let docbizid = this.active_item.docbizid
                let req = this.myaxios.get_doc(`/Wth/DeleteInstance`, { docbizid: docbizid, operator: this.currentUser.dic_worker_id })
                let req2 = this.myaxios.delete(`/api/Nursing/Score/Delete/${this.active_item.id}`)
                this.myaxios.all(req, req2).then(([data, d2]) => {
                    _.remove(this.active_item.allScores, function(item) {
                        return item.docbizid == docbizid
                    })
                    if (this.active_item.allScores && this.active_item.allScores.length > 0) {
                        this.loadscorerecord(this.active_item, this.active_item.allScores[0])
                        this.loadScore()
                    } else {
                        this.loadScore()
                        this.active_item = {}
                        this.dialogFormVisible = false
                    }
                })
            }).catch(e => console.log(e))
        },
        loadScore(documentname) {
            if (!this.surgeryId) return
            this.$store.dispatch(`ADD_SYS_DOCUMENT_LIST`).then(data2 => {
                let documentlist = _.filter(this.sys_document_list, d => { return d.is_enable === true && d.doc_type === 2 }).map(d => {
                    d = { item_code: d.code, item_name: d.label, score_many_times: d.score_many_times }
                    return d
                })
                this.items = documentlist
            }).then(data2 => {
                let req = this.myaxios.get(`/api/Nursing/Score/GetNew?surgeryId=${this.surgeryId}`)
                req.then(data => {
                    let r = _.map(this.items, d => {
                        let f = _.find(data, { document_name: d.item_code })
                        let level = `info`
                        if (f) {
                            switch (d.item_code) {
                            case `PF015`:level = f.result >= 12 ? `info` : f.result >= 9 ? `warning` : `danger`; break
                            }
                        }
                        return Object.assign({ level: level, docbizid: f && f.document_id }, d, f || {})
                    })
                    // #region ACIS-24024 评分功能，分数和等级颜色警示
                    _.forEach(r, b => {
                        var config = _.find(this.defaultConfig, c => b.item_name == c.name)
                        if (config) {
                            // 是否范围
                            if (config.isArea) {
                                var area = _.find(config.Areas, area => b.result >= area.min && b.result <= area.max)
                                if (area) {
                                    b.color = area.color
                                } else {
                                    b.color = `black`
                                }
                            } else {
                                var areaconfig = _.find(config.Areas, area => b.result == area.score)
                                if (areaconfig) {
                                    b.color = areaconfig.color
                                } else {
                                    b.color = `black`
                                }
                            }
                        } else {
                            (
                                b.color = `black`
                            )
                        }
                        _.forEach(b.allScores, sc => {
                            sc.docbizid = sc.document_id
                            sc.item_code = b.item_code
                            sc.item_name = b.item_name
                            sc.level = b.level
                            sc.score_many_times = b.score_many_times
                            if (config) {
                            // 是否范围
                                if (config.isArea) {
                                    var area = _.find(config.Areas, area => sc.result >= area.min && sc.result <= area.max)
                                    if (area) {
                                        sc.color = area.color
                                    } else {
                                        sc.color = this.$getThemePrimaryColor()
                                    }
                                } else {
                                    var areaconfig = _.find(config.Areas, area => sc.result == area.score)
                                    if (areaconfig) {
                                        sc.color = areaconfig.color
                                    } else {
                                        sc.color = this.$getThemePrimaryColor()
                                    }
                                }
                            } else {
                                (
                                    sc.color = this.$getThemePrimaryColor()
                                )
                            }
                        })
                    })
                    // #endregion
                    this.scoreItems = r
                    if (documentname) {
                        this.active_item = _.filter(this.scoreItems, d => { return d.document_name === this.active_item.document_name })[0]
                        this.loadscorerecord(this.active_item, this.active_item)
                    }
                }).catch(e => console.log(e))
            })
        },
        deleteDoc(item) {
            this.$confirm(`此操作将永久删除本次评分记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.get_doc(`/Wth/DeleteInstance`, { docbizid: item.docbizid, operator: this.currentUser.dic_worker_id })
                let req2 = this.myaxios.delete(`/api/Nursing/Score/Delete/${item.id}`)
                this.myaxios.all(req, req2).then(([data, d2]) => {
                    this.active_item = {}
                    this.loadScore()
                })
            }).catch(e => console.log(e))
        },
        addDoc(item) {
            this.active_item = {
                docbizid: ``,
                item_code: item.item_code,
                item_name: item.item_name,
                level: item.level,
                score_many_times: item.score_many_times,
                allScores: item.allScores
            }
            window.localStorage.setItem(`docsingleton`, null) // 非单例
            this.dialogFormVisible = true
            this.$nextTick(() => {
                this.$refs.doc && this.$refs.doc.loadDocument()
            })
        },
        loadscorerecord(activeitem, scoreitem) {
            scoreitem.allScores = activeitem.allScores
            this.active_item = scoreitem
            this.$nextTick(() => {
                this.$refs.doc && this.$refs.doc.loadDocument()
            })
        },
        getLog(item) {
            let title = ``
            let num = 1
            // 获取历史记录 最多三条
            _.forEach(item.allScores, sc => {
                if (num <= 3) {
                    title += `${this.$moment(sc.modify_date).format(`MM/DD HH:mm`)} ${sc.modifier} ${sc.result}分\r\n`
                }
                num++
            })
            return title
        },
        printScore() { // 打印
            if (this.$refs.doc.changed) {
                this.$message.error(`请先保存评分`)
                return
            }
            this.$refs.doc.print()
            setTimeout(this.loadScore(), 3000)
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.active_item = {}
            this.loadScore()
        }
    }
}
</script>
<style scoped lang="less">
.score-item {
    border: solid 0.5px lightgray;
    box-shadow: 2px 2px 5px lightgrey;
    height: 120px;
    overflow: hidden;
    position: relative;
    &.scored:hover {
        .score-left {
            width: 80%;
        }
        .score-delete {
            left: 80%;
        }
        .score {
            left: 80%;
        }
    }
    .score-main {
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .score-delete {
        width: 20%;
        position: absolute;
        left: 100%;
        top: 0;
        // background: darkcyan;
        height: 100%;
        align-items: center;
        display: flex;
        justify-content: center;
        color: white;
        opacity: 0.7;
        &:hover {
            opacity: 0.8;
        }
    }
    .score {
        width: 20%;
        position: absolute;
        left: 100%;
        top: 0;
        // background: darkcyan;
        height: 100%;
    }
    .score-delete-new {
        background-color: #e63939;
        width: 100%;
        height: 50%;
        align-items: center;
        display: flex;
        justify-content: center;
        color: white;
        opacity: 0.7;
        &:hover {
            opacity: 1;
        }
    }
    .score-add {
        width: 100%;
        height: 50%;
        align-items: center;
        display: flex;
        justify-content: center;
        color: white;
        opacity: 0.7;
        &:hover {
            opacity: 1;
        }
    }
}

.score-record {
    text-align: left;
    color: black;
    border: solid;
    border-width: 2px 0px 5px 0px;
    background: white;
    border-color: #fafafa;
    &:hover {
        background: var(--primary-light, #e6f5f3);
        cursor: pointer;
    }
}
.score-record-active {
    text-align: left;
    color: black;
    border: solid;
    border-width: 2px 0px 5px 0px;
    background: var(--primary-lighter, #d7f3ef);
    border-color: #fafafa;
    &:hover {
        background: var(--primary-light, #e6f5f3);
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Score/Index2.vue